import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const searchTransaction = ({ text, pageNumber = 0 }) => {
  if (!text) return Promise.resolve({ data: { transactions: [] } }); // Prevents API call if text is empty
  return axios.get(`/transaction/search/${text}/${pageNumber}`);
};

export const useSearchTransaction = ({ text = '', config = {} }) => {
  return useQuery({
    ...config,
    queryKey: ['transaction_search_results', text],
    queryFn: () => searchTransaction({ text }),
    enabled: !!text, // Only fetch when text is provided
  });
};
